import { createSlice } from "@reduxjs/toolkit";

export const deviceconfigdata = createSlice({
    name: 'deviceconfigdata',

    initialState: {
        deviceno:[],
        gatewayList:[],
        searchList:[],
        addDevice: 0,
        editDeviceData: 0

    },

    reducers: {
        updatedeviceno: (state, data) => {
            state.deviceno =[...state.deviceno,data.payload];
        },
        getdeviceno: (state, data) => { 
            state.deviceno = data.payload
        },
        getgatwaylist: (state, data) => {
            state.gatewayList = data.payload
        },
        assetsearch: (state, data) => {
            state.deviceno = data.payload
            let filter = data.payload.filterSelected
            let searchtext = data.payload.searchText
            let temp = [];
            state.deviceno.filter((value)=>{
                // if(Object.keys(value.data).includes(filter)){
                // }searchtext;
                Object.keys(value.data).forEach(key => {
                    if (key === filter && value.data[key] === searchtext) {
                        temp=[...temp,value];
                    }
                });
            })
            state.searchList=temp;
        },
        updatedevicedata: (state, data) => {
            let arrindex;
            state.deviceno.map((value,index)=>{
                // if(Object.keys(value.data).includes(filter)){
                // }searchtext;
                if(value.id==data.payload.id){
                    arrindex=index;
                }
            })
            state.deviceno.splice(arrindex,1,data.payload)
        },
        updateAddDevice: (state, data) => {
        state.addDevice = data.payload;
        },
        setEditDeviceData: (state, data) => {
                state.editDeviceData = data.payload;
        }
    }
})

export const {updatedeviceno, getdeviceno,getgatwaylist,devicesearch,updatedevicedata,updateAddDevice, setEditDeviceData} = deviceconfigdata.actions
export default deviceconfigdata.reducer